export default __webpack_public_path__ + "static/media/dash-icon-placeholder.eb46f4ec.svg";